import {
    ColumnsSettingsViewDict,
    DropdownChooserItem,
    ValidationResultItem
} from '../typings/common';
import {
    Deal,
    DealDetail,
    DealDetailCampaign,
    DealsData,
    DealsSourceParams,
    DealsUpdateObject
} from '../typings/deals';

export const UPDATE_DEALS_DATA = 'UPDATE_DEALS_DATA';
export type UPDATE_DEALS_DATA = typeof UPDATE_DEALS_DATA;
export const RESET_DEALS_DATA = 'RESET_DEALS_DATA';
export type RESET_DEALS_DATA = typeof RESET_DEALS_DATA;
export const UPDATE_DEALS_SOURCE_PARAMS = 'UPDATE_DEALS_SOURCE_PARAMS';
export type UPDATE_DEALS_SOURCE_PARAMS = typeof UPDATE_DEALS_SOURCE_PARAMS;
export const OPEN_DEAL_INSPECTOR = 'OPEN_DEAL_INSPECTOR';
export type OPEN_DEAL_INSPECTOR = typeof OPEN_DEAL_INSPECTOR;
export const CLOSE_DEAL_INSPECTOR = 'CLOSE_DEAL_INSPECTOR';
export type CLOSE_DEAL_INSPECTOR = typeof CLOSE_DEAL_INSPECTOR;
export const TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR =
    'TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR';
export type TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR = typeof TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR;
export const UPDATE_DEAL_DATA_INSPECTOR = 'UPDATE_DEAL_DATA_INSPECTOR';
export type UPDATE_DEAL_DATA_INSPECTOR = typeof UPDATE_DEAL_DATA_INSPECTOR;
export const ACCEPT_REJECT_DEALS = 'ACCEPT_REJECT_DEALS';
export type ACCEPT_REJECT_DEALS = typeof ACCEPT_REJECT_DEALS;
export const SHOW_INSPECTOR_ERRORS = 'SHOW_INSPECTOR_ERRORS';
export type SHOW_INSPECTOR_ERRORS = typeof SHOW_INSPECTOR_ERRORS;
export const CLEAR_INSPECTOR_ERRORS = 'CLEAR_INSPECTOR_ERRORS';
export type CLEAR_INSPECTOR_ERRORS = typeof CLEAR_INSPECTOR_ERRORS;
export const REQUSET_DEALS_ROW = 'REQUSET_DEALS_ROW';
export type REQUSET_DEALS_ROW = typeof REQUSET_DEALS_ROW;
export const RESET_DEALS_CACHE_KEYS = 'RESET_DEALS_CACHE_KEYS';
export type RESET_DEALS_CACHE_KEYS = typeof RESET_DEALS_CACHE_KEYS;
export const UPDATE_DEALS = 'UPDATE_DEALS';
export type UPDATE_DEALS = typeof UPDATE_DEALS;
export const UPDATE_DEALS_DATA_ITEM = 'UPDATE_DEALS_DATA_ITEM';
export type UPDATE_DEALS_DATA_ITEM = typeof UPDATE_DEALS_DATA_ITEM;
export const UPDATE_DEALS_COLUMNS_WIDTH = 'UPDATE_DEALS_COLUMNS_WIDTH';
export type UPDATE_DEALS_COLUMNS_WIDTH = typeof UPDATE_DEALS_COLUMNS_WIDTH;
export const CHANGE_DEALS_COLUMNS_VISIBILITY =
    'CHANGE_DEALS_COLUMNS_VISIBILITY';
export type CHANGE_DEALS_COLUMNS_VISIBILITY = typeof CHANGE_DEALS_COLUMNS_VISIBILITY;
export const CHANGE_DEALS_COLUMNS_ORDER = 'CHANGE_DEALS_COLUMNS_ORDER';
export type CHANGE_DEALS_COLUMNS_ORDER = typeof CHANGE_DEALS_COLUMNS_ORDER;
export const SHOW_INSPECTOR_DATA_API_ERROR = 'SHOW_INSPECTOR_DATA_API_ERROR';
export type SHOW_INSPECTOR_DATA_API_ERROR = typeof SHOW_INSPECTOR_DATA_API_ERROR;

export const LOAD_CAMPAIGNS_DEALS = 'LOAD_CAMPAIGNS_DEALS';
export const UPDATE_CAMPAIGNS_DEALS = 'UPDATE_CAMPAIGNS_DEALS';
export const CLEAR_CAMPAIGNS_DEALS = 'CLEAR_CAMPAIGNS_DEALS';
export type LOAD_CAMPAIGNS_DEALS = typeof LOAD_CAMPAIGNS_DEALS;
export type UPDATE_CAMPAIGNS_DEALS = typeof UPDATE_CAMPAIGNS_DEALS;
export type CLEAR_CAMPAIGNS_DEALS = typeof CLEAR_CAMPAIGNS_DEALS;

export const LOAD_CLIENTS_DEALS = 'LOAD_CLIENTS_DEALS';
export const UPDATE_CLIENTS_DEALS = 'UPDATE_CLIENTS_DEALS';
export const CLEAR_CLIENTS_DEALS = 'CLEAR_CLIENTS_DEALS';
export type LOAD_CLIENTS_DEALS = typeof LOAD_CLIENTS_DEALS;
export type UPDATE_CLIENTS_DEALS = typeof UPDATE_CLIENTS_DEALS;
export type CLEAR_CLIENTS_DEALS = typeof CLEAR_CLIENTS_DEALS;

export interface LoadClientsDealsAction {
    type: LOAD_CLIENTS_DEALS;
    login: string;
}

export function loadClientsDeals(login: string): LoadClientsDealsAction {
    return {
        type: LOAD_CLIENTS_DEALS,
        login
    };
}

export interface UpdateClientsDealsAction {
    type: UPDATE_CLIENTS_DEALS;
    items: DropdownChooserItem[];
}

export function updateClientsDeals(
    items: DropdownChooserItem[]
): UpdateClientsDealsAction {
    return {
        type: UPDATE_CLIENTS_DEALS,
        items
    };
}

export interface ClearClientsDealsAction {
    type: CLEAR_CLIENTS_DEALS;
}

export function clearClientsDeals(): ClearClientsDealsAction {
    return {
        type: CLEAR_CLIENTS_DEALS
    };
}

export interface LoadCampaignsDealsAction {
    type: LOAD_CAMPAIGNS_DEALS;
    client: string;
}

export function loadCampaignsDeals(client: string): LoadCampaignsDealsAction {
    return {
        type: LOAD_CAMPAIGNS_DEALS,
        client
    };
}

export interface UpdateCampaignsDealsAction {
    type: UPDATE_CAMPAIGNS_DEALS;
    items: DropdownChooserItem[];
    client: string;
}

export function updateCampaignsDeals(
    items: DropdownChooserItem[],
    client: string
): UpdateCampaignsDealsAction {
    return {
        type: UPDATE_CAMPAIGNS_DEALS,
        items,
        client
    };
}

export interface ClearCampaignsDealsAction {
    type: CLEAR_CAMPAIGNS_DEALS;
    client: string;
}

export function clearCampaignsDeals(client: string): ClearCampaignsDealsAction {
    return {
        type: CLEAR_CAMPAIGNS_DEALS,
        client
    };
}

export interface UpdateDealsData {
    type: UPDATE_DEALS_DATA;
    gridData: DealsData;
    dealsCacheKey: string;
}

export function updateDealsData(
    gridData: DealsData,
    dealsCacheKey: string
): UpdateDealsData {
    return {
        type: UPDATE_DEALS_DATA,
        gridData,
        dealsCacheKey
    };
}

export interface ResetDealsData {
    type: RESET_DEALS_DATA;
}

export function resetDealsData(): ResetDealsData {
    return { type: RESET_DEALS_DATA };
}

export interface ResetDealsCacheKeys {
    type: RESET_DEALS_CACHE_KEYS;
}

export function resetDealsCacheKeys(): ResetDealsCacheKeys {
    return {
        type: RESET_DEALS_CACHE_KEYS
    };
}

export interface UpdateDealsSourceParams {
    type: UPDATE_DEALS_SOURCE_PARAMS;
    sourceParams: DealsSourceParams;
}

export function updateDealsSourceParams(
    sourceParams: DealsSourceParams
): UpdateDealsSourceParams {
    return {
        type: UPDATE_DEALS_SOURCE_PARAMS,
        sourceParams
    };
}

export interface OpenDealInspector {
    type: OPEN_DEAL_INSPECTOR;
    index: number;
}

export function openDealInspector(index: number): OpenDealInspector {
    return {
        type: OPEN_DEAL_INSPECTOR,
        index
    };
}

export interface CloseDealInspector {
    type: CLOSE_DEAL_INSPECTOR;
}

export function closeDealInspector(): CloseDealInspector {
    return { type: CLOSE_DEAL_INSPECTOR };
}

// cyn@todo https://st.yandex-team.ru/DIRECT-82988
// этот флаг мог бы быть вычислимым, если перенести все про инспектор в store
export interface ToogleIndicatorOfChangesDataInspector {
    type: TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR;
    isInspectorHasChanges: boolean;
}

export function toogleIndicatorOfChangesDataInspector(
    isInspectorHasChanges: boolean
): ToogleIndicatorOfChangesDataInspector {
    return {
        type: TOOGLE_INDICATOR_OF_CHANGES_DATA_INSPECTOR,
        isInspectorHasChanges
    };
}

export interface UpdateDealDataInspector {
    type: UPDATE_DEAL_DATA_INSPECTOR;
    campaigns: DealDetailCampaign[];
    deal: Deal;
    errors: ValidationResultItem[];
    requestParams?: DealsUpdateObject;
}

export function updateDealDataInspector(
    detail: DealDetail,
    errors: ValidationResultItem[] = [],
    requestParams?: DealsUpdateObject
): UpdateDealDataInspector {
    const { campaigns, deal } = detail;

    return {
        type: UPDATE_DEAL_DATA_INSPECTOR,
        campaigns,
        deal,
        errors,
        requestParams
    };
}

export interface UpdateDeals {
    type: UPDATE_DEALS;
    login: string;
    dealIds: number[];
    updateObject: DealsUpdateObject;
}

export function updateDeals(
    login: string,
    dealIds: number[],
    updateObject: DealsUpdateObject
): UpdateDeals {
    return {
        type: UPDATE_DEALS,
        login,
        dealIds,
        updateObject
    };
}

export interface AcceptRejectDeals {
    type: ACCEPT_REJECT_DEALS;
    login: string;
    dealIds: number[];
    isAccept: boolean;
    updateObject: DealsUpdateObject | null;
}

export function acceptRejectDeals(
    login: string,
    dealIds: number[],
    isAccept: boolean,
    updateObject: DealsUpdateObject | null
): AcceptRejectDeals {
    return {
        type: ACCEPT_REJECT_DEALS,
        login,
        dealIds,
        isAccept,
        updateObject
    };
}

export interface ShowInspectorErrors {
    type: SHOW_INSPECTOR_ERRORS;
    errors: ValidationResultItem[];
    requestParams?: DealsUpdateObject;
}

export function showInspectorErrors(
    errors: ValidationResultItem[],
    requestParams?: DealsUpdateObject
): ShowInspectorErrors {
    return {
        type: SHOW_INSPECTOR_ERRORS,
        requestParams,
        errors
    };
}

export interface ClearInspectorErrors {
    type: CLEAR_INSPECTOR_ERRORS;
    pathes: string[];
}

export function clearInspectorErrors(pathes: string[]): ClearInspectorErrors {
    return {
        type: CLEAR_INSPECTOR_ERRORS,
        pathes
    };
}

export interface RequestDealsRow {
    type: REQUSET_DEALS_ROW;
    index: number;
}

export function requestDealsRow(index: number): RequestDealsRow {
    return {
        type: REQUSET_DEALS_ROW,
        index
    };
}

export interface UpdateDealsDataItem {
    type: UPDATE_DEALS_DATA_ITEM;
    deal: Deal;
}

export function updateDealsDataItem(deal: Deal): UpdateDealsDataItem {
    return {
        type: UPDATE_DEALS_DATA_ITEM,
        deal
    };
}

export interface UpdateDealsColumnsWidthData {
    type: UPDATE_DEALS_COLUMNS_WIDTH;
    columns: ColumnsSettingsViewDict;
}

export function updateDealsColumnsWidthData(
    settings: ColumnsSettingsViewDict
): UpdateDealsColumnsWidthData {
    return {
        type: UPDATE_DEALS_COLUMNS_WIDTH,
        columns: settings
    };
}

export const HANDLE_DEALS_COLUMNS_WIDTH_UPDATE =
    'HANDLE_DEALS_COLUMNS_WIDTH_UPDATE';
export type HANDLE_DEALS_COLUMNS_WIDTH_UPDATE = typeof HANDLE_DEALS_COLUMNS_WIDTH_UPDATE;

export interface HandleDealsColumnsWidthUpdateAction {
    type: HANDLE_DEALS_COLUMNS_WIDTH_UPDATE;
    width: number;
    key: string;
}

export function handleDealsColumnsWidthUpdate(
    width: number,
    key: string
): HandleDealsColumnsWidthUpdateAction {
    return {
        type: HANDLE_DEALS_COLUMNS_WIDTH_UPDATE,
        width,
        key
    };
}

export interface ChangeDealsColumnsVisibilityData {
    type: CHANGE_DEALS_COLUMNS_VISIBILITY;
    columns: ColumnsSettingsViewDict;
}

export function changeDealsColumnsVisibilityData(
    settings: ColumnsSettingsViewDict
): ChangeDealsColumnsVisibilityData {
    return {
        type: CHANGE_DEALS_COLUMNS_VISIBILITY,
        columns: settings
    };
}

export const HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE =
    'HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE';
export type HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE = typeof HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE;

export interface HandleDealsColumnsVisibilityChangeAction {
    type: HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE;
    columns: string[];
}

export function handleDealsColumnsVisibilityChange(
    columns: string[]
): HandleDealsColumnsVisibilityChangeAction {
    return {
        type: HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE,
        columns
    };
}

export interface ChangeDealsColumnsOrderData {
    type: CHANGE_DEALS_COLUMNS_ORDER;
    columnOrder: Array<string>;
}

export function changeDealsColumnsOrderData(
    order: Array<string>
): ChangeDealsColumnsOrderData {
    return {
        type: CHANGE_DEALS_COLUMNS_ORDER,
        columnOrder: order
    };
}

export const HANDLE_DEALS_COLUMNS_ORDER_CHANGE =
    'HANDLE_DEALS_COLUMNS_ORDER_CHANGE';
export type HANDLE_DEALS_COLUMNS_ORDER_CHANGE = typeof HANDLE_DEALS_COLUMNS_ORDER_CHANGE;

export interface HandleDealsColumnsOrderChangeAction {
    type: HANDLE_DEALS_COLUMNS_ORDER_CHANGE;
    columnOrder: string[];
}

export function handleDealsColumnsOrderChange(
    columnOrder: string[]
): HandleDealsColumnsOrderChangeAction {
    return {
        type: HANDLE_DEALS_COLUMNS_ORDER_CHANGE,
        columnOrder
    };
}

export interface ShowInspectorDataApiError {
    type: SHOW_INSPECTOR_DATA_API_ERROR;
    error: string;
}

export function showInspectorDataApiError(
    error: string
): ShowInspectorDataApiError {
    return {
        type: SHOW_INSPECTOR_DATA_API_ERROR,
        error
    };
}

export const UPDATE_COLUMNS_SETTINGS_DEALS_STATE =
    'UPDATE_COLUMNS_SETTINGS_DEALS_STATE';
export type UPDATE_COLUMNS_SETTINGS_DEALS_STATE = typeof UPDATE_COLUMNS_SETTINGS_DEALS_STATE;

export interface UpdateColumnsSettingsDealsState {
    type: UPDATE_COLUMNS_SETTINGS_DEALS_STATE;
    columnsSettings: ColumnsSettingsViewDict;
}

export const updateColumnsSettingsDealsState = (
    columnsSettings: ColumnsSettingsViewDict
): UpdateColumnsSettingsDealsState => {
    return {
        type: UPDATE_COLUMNS_SETTINGS_DEALS_STATE,
        columnsSettings
    };
};

export type DealsAction =
    | LoadClientsDealsAction
    | UpdateClientsDealsAction
    | ClearClientsDealsAction
    | LoadCampaignsDealsAction
    | UpdateCampaignsDealsAction
    | ClearCampaignsDealsAction
    | UpdateDealsData
    | ResetDealsData
    | UpdateDealsSourceParams
    | OpenDealInspector
    | CloseDealInspector
    | UpdateDealDataInspector
    | UpdateDeals
    | AcceptRejectDeals
    | ShowInspectorErrors
    | ClearInspectorErrors
    | RequestDealsRow
    | ResetDealsCacheKeys
    | UpdateDealsDataItem
    | ToogleIndicatorOfChangesDataInspector
    | UpdateDealsColumnsWidthData
    | ChangeDealsColumnsVisibilityData
    | ChangeDealsColumnsOrderData
    | ShowInspectorDataApiError
    | HandleDealsColumnsWidthUpdateAction
    | HandleDealsColumnsVisibilityChangeAction
    | HandleDealsColumnsOrderChangeAction
    | UpdateColumnsSettingsDealsState;
